import {
  LOADING_PITCH_EDITOR_PAGE, LOAD_PITCH_EDITOR_PAGE_ERROR, LOAD_PITCH_EDITOR_PAGE_SUCCESS, PITCH_EDITOR_NOT_FOUND,
} from 'constants/ActionTypes';
import {
  INITIALIZATION_VECTOR, KEY, CLIENT_ERROR_RESPONSES,
} from 'constants/AppConstants';
import { call, put } from 'lib/redux';
import getReportDetailsService from 'services/getReportDetails.service';
import getReportFacetsService from 'services/getReportFacets.service';
import getReportImageFilesService from 'services/getReportImageFiles.service';
import { decodeAndDecrypt } from 'utils/app.utils';
import { logError } from 'utils/logger.utils';
import history from 'store/CreateHistory';

export default function* loadPitchEditorPageSaga({ reportId: encryptedReportID }) {
  try {
    yield put({ type: LOADING_PITCH_EDITOR_PAGE });
    const signature = new URLSearchParams(history.location.search).get('signature'); // #genai
    const decryptedString = yield call(decodeAndDecrypt, encryptedReportID, KEY, INITIALIZATION_VECTOR);
    const reportId = decryptedString.split(',')[0];

    const reportDetailsResponse = yield call(getReportDetailsService, reportId, signature);
    const reportFacetsResponse = yield call(getReportFacetsService, reportId, signature);
    const reportImageFilesResponse = yield call(getReportImageFilesService, reportId);
    if (reportDetailsResponse.status === CLIENT_ERROR_RESPONSES.STATUS_NOT_FOUND || reportFacetsResponse.status === CLIENT_ERROR_RESPONSES.STATUS_NOT_FOUND
      || reportImageFilesResponse.status === CLIENT_ERROR_RESPONSES.STATUS_NOT_FOUND) {
      yield put({ type: PITCH_EDITOR_NOT_FOUND });
    }
    if (!reportDetailsResponse.ok) {
      const { json: error } = reportDetailsResponse;
      throw error;
    }
    if (!reportFacetsResponse.ok) {
      const { json: error } = reportDetailsResponse;
      throw error;
    }
    if (!reportImageFilesResponse.ok) {
      const { json: error } = reportDetailsResponse;
      throw error;
    }

    const reportDetails = reportDetailsResponse.json;
    const reportFacets = reportFacetsResponse.json;
    const reportImageFiles = reportImageFilesResponse.json;
    yield put({
      type: LOAD_PITCH_EDITOR_PAGE_SUCCESS, reportId, reportDetails, reportFacets, reportImageFiles,
    });
  } catch (error) {
    logError('Error in getGeocodeSaga', {
      error: error.message,
      errorCode: error.errorCode,
      encryptedReportID,
    });
    if (error.code === 5) yield put({ type: PITCH_EDITOR_NOT_FOUND });
    else yield put({ type: LOAD_PITCH_EDITOR_PAGE_ERROR });
  }
}
